<div id="rvrsSearchPointModal" *ngIf="showModal">
  <app-confirm-dialog [openModal]="showConfirm"></app-confirm-dialog>
  <div class="screen"></div>
  <div class="dialog">
    <div class="dialogHeader">
      <h2>
        <div class="closeDelete" role="button" (click)="onCancel()">
          <span class="cvt-icon-closeDelete">
          </span>
        </div>
        Select a Search Point
      </h2>
    </div>
    <div class="dialogBody">
      <div>
        <div class="col1">
          <div id="searchInput">
            <div class="rowContainer rowHeader">Address / Airport Code Search</div>
            <div class="rowContainer">
              <span class="inlineBlock">
                <fieldset ngl-radio-group>
                  <ngl-radio-option label="Lookup Airport Code" class="radio">
                    <input ngl type="radio" [checked]="true" [(ngModel)]="searchType" value="Airport" />
                  </ngl-radio-option>
                  <ngl-radio-option label="Lookup Address" class="radio">
                    <input ngl type="radio" [(ngModel)]="searchType" value="Address" />
                  </ngl-radio-option>
                </fieldset>
              </span>
              <label for="searchRadius">
                Search Radius (mi.)
              </label>
              <kendo-numerictextbox id="searchRadius" [(ngModel)]="searchRadiusMiles" [min]="1" [max]="20"
                [autoCorrect]="true" [format]="'n0'"  (keydown)="blockDelete($event)" ></kendo-numerictextbox>
              <span class="max20">Max 20</span>
            </div>
            <div class="rowContainer">
              <label for="searchTermInput">Search Address/Airport Code</label>
              <input type="text" id="searchTermInput" [(ngModel)]="searchTerm" (keyup)="keyup($event)" />
              <button (click)="lookupAddress($event)" class="k-button cvt-primary">Lookup Address</button>
            </div>
          </div>
          <div id="pointInfo">
            <div class="rowContainer rowHeader">
              Search Point
            </div>
            <div class="rowContainer">
              <label for="searchPointName">
                Name
                <span class="asterix">*</span>
              </label>
              <input type="text" id="searchPointName" [(ngModel)]="searchPoint.Name" />
              <label for="searchPointType">
                Type
              </label>
              <input type="text" id="searchPointType" [value]="(searchPoint.Type==2?'Airport':'Address')" readonly />
            </div>
            <div class="rowContainer">
              <label for="addressInput">
                Address
                <span class="asterix">*</span>
              </label>
              <input type="text" id="addressInput" [(ngModel)]="searchPoint.PropertyAddress" />
            </div>
            <div class="rowContainer">
              <label class="inlineBlock">
                Geocode
                <span class="asterix">*</span>
              </label>
              <input type="text" [(ngModel)]="searchPoint.geocode" (blur)="checkGeocode($event)" />
            </div>
          </div>
        </div>
        <div class="col2">
          <div class="rowContainer rowHeader">
            Search Area
          </div>
          <div id="googleMap">
            <div>
              <div #MapDisplay id="mapDisplay">

              </div>
              <div class="mapNotes">
                <span>&nbsp; Radius
                  <span id="mapRadiusLabel" [innerText]="mapRadius"></span> miles</span>
                <span *ngIf="SearchStatus"> &nbsp; &bull;&nbsp;</span>
                <span id="SearchStatus" [innerText]="SearchStatus"></span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="rowContainer buttonRow">
        <button (click)="onCancel()" class="k-button cvt-secondary">Cancel</button>
        <button (click)="onOk()" class="k-button cvt-primary">Ok</button>
      </div>
    </div>
  </div>
</div>
